var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useRef, useEffect, useContext } from "react";
import styled from "styled-components";
import { PlayerContext } from "app/PlayerContext";
import { Id } from "core/utils";
export var View = function (_a) {
    var html = _a.html, className = _a.className;
    var playerRef = useRef(null);
    var setPlayer = useContext(PlayerContext).setPlayer;
    useEffect(function () {
        setPlayer(playerRef);
    }, []);
    return (React.createElement(Player, { className: className, "data-component": Id.component.player, dangerouslySetInnerHTML: {
            __html: html,
        }, ref: playerRef }));
};
var Player = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 0.5rem;\n  overflow: hidden;\n  transform: translate3d(0, 0, 0);\n"], ["\n  border-radius: 0.5rem;\n  overflow: hidden;\n  transform: translate3d(0, 0, 0);\n"])));
var templateObject_1;
